import { render } from "./SessionLogs.vue?vue&type=template&id=0768d5d3&scoped=true"
import script from "./SessionLogs.vue?vue&type=script&lang=js"
export * from "./SessionLogs.vue?vue&type=script&lang=js"

import "./SessionLogs.vue?vue&type=style&index=0&id=0768d5d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0768d5d3"]])

export default __exports__